import React from 'react';
import { Award, Users, Target, CheckCircle, ArrowRight, Zap, Shield, Cloud } from 'lucide-react';
import Reveal from './Reveal';

const About: React.FC = () => {
  const features = [
    {
      icon: <Award className="w-8 h-8" />,
      title: 'Experiencia',
      description: 'Más de 19 años de experiencia en soluciones IT.',
    },
    {
      icon: <Users className="w-8 h-8" />,
      title: 'Compromiso',
      description: 'Equipo dedicado y comprometido con el éxito de cada proyecto.',
    },
    {
      icon: <Target className="w-8 h-8" />,
      title: 'Dinamismo',
      description: 'Adaptación rápida a las nuevas tecnologías y metodologías.',
    },
    {
      icon: <CheckCircle className="w-8 h-8" />,
      title: 'Cultura de Excelencia',
      description: 'Comprometidos con la calidad, innovación y mejores prácticas en cada proyecto.',
    }
  ];

  return (
    <section id="about" className="section-padding bg-secondary-900 relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-24 left-10 w-72 h-72 bg-accent-500/5 rounded-full blur-3xl" />
        <div className="absolute bottom-10 right-10 w-64 h-64 bg-accent-600/5 rounded-full blur-3xl" />
      </div>

      <div className="container-custom relative z-10">
        <Reveal className="text-center mb-16">
          <div className="section-badge">
            <Award className="w-4 h-4 mr-2" />
            Sobre Nosotros
          </div>

          <h2 className="section-title">
            Expertos en
            <span className="text-accent-400 block">Cloud Technology</span>
          </h2>

          <p className="section-subtitle max-w-4xl">
            Somos una empresa de tecnología especializada en soluciones
            Cloud y DevSecOps.
            <br />
            <br />
            Nuestra experiencia abarca entornos multi-cloud (AWS, Azure, etc) con
            un enfoque integral en seguridad, escalabilidad y optimización de costos.
          </p>
        </Reveal>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-20">
          {features.map((feature, index) => (
            <Reveal key={feature.title} delay={index * 0.08}>
              <div className="group h-full">
                <div className="surface-card p-8 h-full card-hover hover:border-accent-500/40">
                  <div className="text-accent-400 mb-6 transition-transform duration-300 group-hover:scale-105">
                    {feature.icon}
                  </div>
                  <h3 className="text-xl font-bold text-white mb-4">{feature.title}</h3>
                  <p className="text-gray-400 leading-relaxed">{feature.description}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <Reveal>
            <div className="space-y-8">
              <h3 className="text-4xl md:text-5xl font-bold text-white">
                ¿Por qué elegirnos?
              </h3>
              <p className="text-lg text-gray-400 leading-relaxed">
                Nuestro enfoque integral combina experiencia técnica, metodologías ágiles
                y un profundo entendimiento de las necesidades del negocio para entregar
                soluciones cloud que realmente transforman tu infraestructura.
              </p>
              <a href="#contact" className="btn-primary inline-flex items-center py-4 px-8">
                Contactanos
                <ArrowRight className="w-5 h-5 ml-2" />
              </a>
            </div>
          </Reveal>

          <Reveal delay={0.12}>
            <div className="relative">
              <div className="bg-gradient-to-br from-surface-overlay to-secondary-900 border border-accent-500/30 rounded-3xl p-12 h-96 flex items-center justify-center relative overflow-hidden">
                <div className="absolute inset-0 bg-accent-500/5" />
                <div className="absolute top-8 left-8 text-accent-500/25">
                  <Cloud className="w-12 h-12 animate-float-soft" />
                </div>
                <div className="absolute top-8 right-8 text-accent-500/20">
                  <Zap className="w-10 h-10 animate-float-soft" style={{ animationDelay: '2s' }} />
                </div>
                <div className="absolute bottom-8 left-8 text-accent-500/20">
                  <Shield className="w-14 h-14 animate-float-soft" style={{ animationDelay: '3.5s' }} />
                </div>
                <div className="absolute bottom-8 right-8 text-accent-500/20">
                  <Target className="w-11 h-11 animate-float-soft" style={{ animationDelay: '1s' }} />
                </div>

                <div className="text-center text-white relative z-10">
                  <div className="w-20 h-20 bg-accent-500/15 border border-accent-500/30 rounded-2xl mx-auto mb-6 flex items-center justify-center">
                    <Zap className="w-9 h-9 text-accent-400" />
                  </div>
                  <h4 className="text-2xl font-bold mb-2">Innovación Constante</h4>
                  <p className="text-gray-400">Tecnología de vanguardia</p>
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default About;
